import { StrapiSingleType, StrapiType } from "@/src/type/strapi";
import { get, StrapiApiServiceType } from "./StrapiService";

async function getWebConfig(locale?: string) {
  const response = await get<StrapiType.StrapiSingleWrapper<StrapiSingleType.WebConfig>>("web-config", locale ?? "en");
  return getType<StrapiSingleType.WebConfig>(response);
}

function getType<T>(response: StrapiApiServiceType<StrapiType.StrapiSingleWrapper<T>>): T | undefined {
  const data = response?.response?.data?.attributes;
  if (data) {
    //@ts-ignore
    data["id"] = response?.response?.data?.id;
  }
  return data;
}

export default {
  getWebConfig,
};
